/* Ayudate · Buscador de cursos */


import { CURSO, infoCurso } from "../datos/areas";
import { norm } from "./formato";

/* Los códigos de la UCR llevan guion (MA-1001) y los del Tec no (MA1102).
   Para comparar da igual: quien escribe "ma1001" o "ma 1001" busca el mismo
   curso que quien escribe "ma-1001", así que el guion y los espacios se
   quitan de los dos lados antes de comparar. Solo aplica a códigos — en los
   nombres el guion sí separa palabras. */
const normCod = (t) => norm(t).replace(/[\s-]/g, "");

/* Busca por código o por nombre. "mate" devuelve Matemática General, Discreta…
   `areas` acota la búsqueda a una institución (varias áreas a la vez, p. ej.
   los niveles de Colegios): sin lista, busca en todo el catálogo. */
export const buscarCursos = (q, ya = [], areas = null) => {
  const n = norm(q).trim();
  if (n.length < 2) return [];
  return Object.values(CURSO)
    .filter((c) => !areas || areas.includes(c.area))
    .filter((c) => !ya.includes(c.cod))
    .filter((c) => normCod(c.cod).includes(normCod(n)) || norm(c.nom).includes(n)
      || norm(c.areaNom || "").includes(n))
    .sort((a, b) => {
      const pa = norm(a.nom).startsWith(n) || normCod(a.cod).startsWith(normCod(n)) ? 0 : 1;
      const pb = norm(b.nom).startsWith(n) || normCod(b.cod).startsWith(normCod(n)) ? 0 : 1;
      return pa - pb || a.nom.localeCompare(b.nom);
    })
    .slice(0, 8);
};

const coincideCodigo = (cod, n) => normCod(cod).includes(normCod(n));

/* Coincidencia del buscador público (sitio de estudiantes): además del
   substring exacto, compara por prefijo de palabra en cualquier dirección,
   para tolerar variaciones como plurales — "integrales" encuentra el curso
   "Cálculo Diferencial e Integral". */
const coincideAmplio = (texto, n) => {
  const t = norm(texto);
  if (t.includes(n)) return true;
  if (n.length < 4) return false;
  return t.split(/\s+/).some((p) => p.length >= 4 && (p.startsWith(n) || n.startsWith(p)));
};

/* Sugerencias del buscador público: por código de curso o por palabra
   clave, sobre todo el catálogo (no depende de quién esté ofreciéndolo). */
export const buscarCursosPublico = (q) => {
  const n = norm(q).trim();
  if (n.length < 2) return [];
  return Object.values(CURSO)
    .filter((c) => coincideCodigo(c.cod, n) || coincideAmplio(c.nom, n) || coincideAmplio(c.areaNom || "", n))
    .sort((a, b) => {
      const pa = norm(a.nom).startsWith(n) || normCod(a.cod).startsWith(normCod(n)) ? 0 : 1;
      const pb = norm(b.nom).startsWith(n) || normCod(b.cod).startsWith(normCod(n)) ? 0 : 1;
      return pa - pb || a.nom.localeCompare(b.nom);
    })
    .slice(0, 8);
};

/* Si una oferta de tutor (por su código de curso) coincide con lo que
   escribió el estudiante en el buscador público. Sin texto, todo coincide. */
export const cursoCoincideBusqueda = (cod, q) => {
  const n = norm(q).trim();
  if (n.length < 2) return true;
  const c = infoCurso(cod);
  return coincideCodigo(c.cod, n) || coincideAmplio(c.nom, n) || coincideAmplio(c.areaNom || "", n);
};
